/* ============================================
   DIGIFON PRODUCT ADVISOR CHATBOT
   All-in-One Embeddable Widget
   Just add ONE script tag to your Shopify theme
   ============================================ */

(function () {
  'use strict';

  // Prevent double-loading
  if (window.__dfChatbotLoaded) return;
  window.__dfChatbotLoaded = true;

  const SHOP_URL = 'https://www.digifon.ng';
  const PRODUCTS_API = SHOP_URL + '/products.json?limit=250';
  const BOT_NAME = 'Digifon Advisor';

  // ──────────────────────────────
  // Inject CSS (all styles inline)
  // ──────────────────────────────
  function injectStyles() {
    const style = document.createElement('style');
    style.id = 'df-chatbot-styles';
    style.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

      :root {
        --df-primary: #E30505;
        --df-primary-hover: #ff1a1a;
        --df-bg-dark: #0a0a0a;
        --df-bg-panel: #111111;
        --df-bg-msg-bot: #1a1a1a;
        --df-bg-input: #1a1a1a;
        --df-text-pri: #f5f5f5;
        --df-text-sec: #a0a0a0;
        --df-text-mut: #666666;
        --df-border: rgba(255,255,255,0.08);
        --df-border-focus: rgba(227,5,5,0.5);
        --df-font: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      }

      /* Toggle Button */
      #df-chat-toggle {
        position: fixed;
        bottom: 100px;
        right: 24px;
        width: 62px;
        height: 62px;
        border-radius: 50%;
        background: linear-gradient(135deg, #E30505, #b80404);
        border: none;
        cursor: pointer;
        z-index: 999998;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 6px 24px rgba(227,5,5,0.4), 0 2px 8px rgba(0,0,0,0.3);
        transition: all 0.3s cubic-bezier(0.4,0,0.2,1);
        outline: none;
      }
      #df-chat-toggle::before {
        content: '';
        position: absolute;
        inset: -4px;
        border-radius: 50%;
        background: rgba(227,5,5,0.25);
        animation: df-pulse 2s ease-in-out infinite;
        z-index: -1;
      }
      #df-chat-toggle:hover {
        transform: scale(1.08);
        box-shadow: 0 8px 32px rgba(227,5,5,0.55), 0 4px 12px rgba(0,0,0,0.4);
      }
      #df-chat-toggle svg { width: 28px; height: 28px; fill: #fff; transition: all 0.3s ease; }
      #df-chat-toggle .df-icon-close { display: none; }
      #df-chat-toggle.df-active .df-icon-chat { display: none; }
      #df-chat-toggle.df-active .df-icon-close { display: block; }
      #df-chat-toggle.df-active::before { animation: none; opacity: 0; }

      /* Badge */
      #df-chat-badge {
        position: absolute;
        top: -2px;
        right: -2px;
        width: 20px;
        height: 20px;
        background: #22c55e;
        border-radius: 50%;
        border: 2px solid #0a0a0a;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        font-weight: 700;
        color: #fff;
        font-family: var(--df-font);
        animation: df-badge-pop 0.4s cubic-bezier(0.34,1.56,0.64,1);
      }

      /* Panel */
      #df-chat-panel {
        position: fixed;
        bottom: 180px;
        right: 24px;
        width: 400px;
        max-width: calc(100vw - 32px);
        height: 600px;
        max-height: calc(100vh - 140px);
        background: var(--df-bg-panel);
        border-radius: 16px;
        border: 1px solid var(--df-border);
        box-shadow: 0 25px 60px rgba(0,0,0,0.6);
        display: flex;
        flex-direction: column;
        z-index: 999999;
        overflow: hidden;
        font-family: var(--df-font);
        opacity: 0;
        visibility: hidden;
        transform: translateY(20px) scale(0.95);
        transition: opacity 0.35s cubic-bezier(0.4,0,0.2,1),
                    transform 0.35s cubic-bezier(0.4,0,0.2,1),
                    visibility 0.35s,
                    width 0.35s cubic-bezier(0.4,0,0.2,1),
                    height 0.35s cubic-bezier(0.4,0,0.2,1),
                    bottom 0.35s cubic-bezier(0.4,0,0.2,1),
                    right 0.35s cubic-bezier(0.4,0,0.2,1),
                    border-radius 0.35s cubic-bezier(0.4,0,0.2,1);
      }
      #df-chat-panel.df-open {
        opacity: 1;
        visibility: visible;
        transform: translateY(0) scale(1);
      }
      /* Expanded / Maximized */
      #df-chat-panel.df-expanded {
        width: 700px;
        height: 85vh;
        max-height: 85vh;
        bottom: 40px;
        right: 40px;
        border-radius: 20px;
        box-shadow: 0 30px 80px rgba(0,0,0,0.7), 0 0 0 1px rgba(227,5,5,0.15);
      }
      #df-chat-panel.df-expanded .df-compare-table td { min-width: 160px; }
      #df-chat-panel.df-expanded .df-compare-table .df-ct-img { width: 72px; height: 72px; }
      #df-chat-panel.df-expanded .df-compare-table .df-ct-name { max-width: 200px; font-size: 13px; }

      /* Header */
      #df-chat-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px 18px;
        background: linear-gradient(135deg, #0f0f0f, #1a1a1a);
        border-bottom: 1px solid var(--df-border);
        flex-shrink: 0;
      }
      #df-chat-avatar {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        background: linear-gradient(135deg, #E30505, #ff3333);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        box-shadow: 0 0 0 2px rgba(227,5,5,0.2);
      }
      #df-chat-avatar svg { width: 22px; height: 22px; fill: #fff; }
      .df-header-info { flex: 1; min-width: 0; }
      .df-header-title { font-size: 15px; font-weight: 700; color: var(--df-text-pri); line-height: 1.2; }
      .df-header-status {
        font-size: 12px;
        color: #22c55e;
        display: flex;
        align-items: center;
        gap: 5px;
        margin-top: 2px;
      }
      .df-header-status::before {
        content: '';
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #22c55e;
        display: inline-block;
        animation: df-pulse-dot 2s ease-in-out infinite;
      }
      .df-header-btn {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        background: rgba(255,255,255,0.06);
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        flex-shrink: 0;
      }
      .df-header-btn:hover { background: rgba(255,255,255,0.15); }
      .df-header-btn svg { width: 16px; height: 16px; fill: var(--df-text-sec); }
      .df-header-actions { display: flex; gap: 6px; align-items: center; }
      /* Expand / Maximize button - prominent */
      #df-chat-expand {
        width: auto;
        padding: 0 10px;
        gap: 5px;
        background: rgba(227,5,5,0.15);
        border: 1px solid rgba(227,5,5,0.3);
      }
      #df-chat-expand svg { fill: #ff6b6b; }
      #df-chat-expand:hover {
        background: rgba(227,5,5,0.25);
        border-color: rgba(227,5,5,0.5);
      }
      .df-expand-label {
        font-size: 11px;
        font-weight: 600;
        color: #ff6b6b;
        font-family: var(--df-font);
      }
      /* Icon + label toggle */
      #df-chat-expand .df-icon-shrink { display: none; }
      #df-chat-panel.df-expanded #df-chat-expand .df-icon-expand { display: none; }
      #df-chat-panel.df-expanded #df-chat-expand .df-label-expand { display: none; }
      #df-chat-panel.df-expanded #df-chat-expand .df-label-shrink { display: inline !important; }
      #df-chat-panel.df-expanded #df-chat-expand .df-icon-shrink { display: block; }

      /* Messages */
      #df-chat-messages {
        flex: 1;
        overflow-y: auto;
        padding: 18px 16px;
        display: flex;
        flex-direction: column;
        gap: 14px;
        scroll-behavior: smooth;
        background: var(--df-bg-dark);
      }
      #df-chat-messages::-webkit-scrollbar { width: 5px; }
      #df-chat-messages::-webkit-scrollbar-track { background: transparent; }
      #df-chat-messages::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 10px; }

      /* Bubbles */
      .df-msg { display: flex; gap: 10px; max-width: 88%; animation: df-msg-in 0.35s cubic-bezier(0.34,1.56,0.64,1); }
      .df-msg-bot { align-self: flex-start; }
      .df-msg-user { align-self: flex-end; flex-direction: row-reverse; }
      .df-msg-avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: linear-gradient(135deg, #E30505, #ff3333);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-top: 2px;
      }
      .df-msg-avatar svg { width: 15px; height: 15px; fill: #fff; }
      .df-msg-user .df-msg-avatar { background: linear-gradient(135deg, #333, #555); }
      .df-msg-bubble {
        padding: 12px 16px;
        border-radius: 18px;
        font-size: 14px;
        line-height: 1.55;
        color: var(--df-text-pri);
        word-wrap: break-word;
      }
      .df-msg-bot .df-msg-bubble {
        background: var(--df-bg-msg-bot);
        border-bottom-left-radius: 4px;
        border: 1px solid var(--df-border);
      }
      .df-msg-user .df-msg-bubble {
        background: linear-gradient(135deg, #E30505, #c50404);
        border-bottom-right-radius: 4px;
        color: #ffffff;
      }

      /* Typing */
      .df-typing { display: flex; align-items: center; gap: 5px; padding: 14px 18px; }
      .df-typing-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: var(--df-text-mut);
        animation: df-typing-bounce 1.4s ease-in-out infinite;
      }
      .df-typing-dot:nth-child(2) { animation-delay: 0.2s; }
      .df-typing-dot:nth-child(3) { animation-delay: 0.4s; }

      /* Chips */
      .df-chips { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }
      .df-chip {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 8px 14px;
        border-radius: 20px;
        background: rgba(227,5,5,0.1);
        border: 1px solid rgba(227,5,5,0.25);
        color: #ff6b6b;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        font-family: var(--df-font);
        white-space: nowrap;
      }
      .df-chip:hover {
        background: rgba(227,5,5,0.2);
        border-color: rgba(227,5,5,0.5);
        transform: translateY(-1px);
      }
      .df-chip:active { transform: scale(0.97); }

      /* Product Cards */
      .df-products-grid { display: flex; flex-direction: column; gap: 10px; margin-top: 10px; width: 100%; }
      .df-product-card {
        display: flex;
        gap: 12px;
        padding: 12px;
        background: rgba(255,255,255,0.04);
        border: 1px solid var(--df-border);
        border-radius: 10px;
        transition: all 0.3s ease;
        animation: df-card-in 0.4s cubic-bezier(0.34,1.56,0.64,1);
      }
      .df-product-card:hover {
        background: rgba(255,255,255,0.07);
        border-color: rgba(227,5,5,0.3);
        transform: translateY(-1px);
      }
      .df-product-img {
        width: 72px;
        height: 72px;
        border-radius: 8px;
        object-fit: cover;
        flex-shrink: 0;
        background: #1a1a1a;
      }
      .df-product-info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
      .df-product-name {
        font-size: 13px;
        font-weight: 600;
        color: var(--df-text-pri);
        line-height: 1.3;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .df-product-prices { display: flex; align-items: center; gap: 8px; }
      .df-product-price { font-size: 14px; font-weight: 700; color: #E30505; }
      .df-product-compare-price { font-size: 12px; color: var(--df-text-mut); text-decoration: line-through; }
      .df-product-badge {
        display: inline-flex;
        font-size: 10px;
        font-weight: 600;
        padding: 2px 6px;
        border-radius: 4px;
        background: rgba(34,197,94,0.15);
        color: #22c55e;
        margin-left: 4px;
      }
      .df-product-badge.df-sold-out { background: rgba(140,140,140,0.15); color: #8c8c8c; }
      .df-product-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        padding: 7px 14px;
        border-radius: 8px;
        background: linear-gradient(135deg, #E30505, #c50404);
        color: #fff;
        font-size: 12px;
        font-weight: 600;
        text-decoration: none;
        border: none;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-top: auto;
        align-self: flex-start;
        font-family: var(--df-font);
      }
      .df-product-btn:hover {
        background: linear-gradient(135deg, #ff1a1a, #E30505);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(227,5,5,0.3);
      }
      .df-product-btn svg { width: 12px; height: 12px; fill: currentColor; }
      .df-product-btn.df-sold-out-btn { background: #333; cursor: not-allowed; opacity: 0.7; }
      .df-product-btn.df-sold-out-btn:hover { transform: none; box-shadow: none; }

      /* Input */
      #df-chat-input-area {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 14px 16px;
        border-top: 1px solid var(--df-border);
        background: var(--df-bg-panel);
        flex-shrink: 0;
      }
      #df-chat-input {
        flex: 1;
        padding: 11px 16px;
        border-radius: 24px;
        background: var(--df-bg-input);
        border: 1px solid var(--df-border);
        color: var(--df-text-pri);
        font-size: 14px;
        font-family: var(--df-font);
        outline: none;
        transition: all 0.3s ease;
      }
      #df-chat-input::placeholder { color: var(--df-text-mut); }
      #df-chat-input:focus { border-color: var(--df-border-focus); box-shadow: 0 0 0 3px rgba(227,5,5,0.1); }
      #df-chat-send {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        background: linear-gradient(135deg, #E30505, #c50404);
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        flex-shrink: 0;
      }
      #df-chat-send:hover { transform: scale(1.06); box-shadow: 0 4px 16px rgba(227,5,5,0.35); }
      #df-chat-send:active { transform: scale(0.95); }
      #df-chat-send svg { width: 18px; height: 18px; fill: #fff; margin-left: 2px; }

      /* Footer */
      .df-powered {
        text-align: center;
        padding: 8px 0;
        font-size: 11px;
        color: var(--df-text-mut);
        background: var(--df-bg-panel);
        border-top: 1px solid rgba(255,255,255,0.03);
      }
      .df-powered a { color: #E30505; text-decoration: none; font-weight: 600; }

      /* Animations */
      @keyframes df-pulse {
        0%, 100% { transform: scale(1); opacity: 0.5; }
        50% { transform: scale(1.35); opacity: 0; }
      }
      @keyframes df-pulse-dot { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
      @keyframes df-typing-bounce { 0%, 60%, 100% { transform: translateY(0); } 30% { transform: translateY(-6px); } }
      @keyframes df-msg-in { from { opacity: 0; transform: translateY(10px) scale(0.96); } to { opacity: 1; transform: translateY(0) scale(1); } }
      @keyframes df-card-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
      @keyframes df-badge-pop { from { transform: scale(0); } to { transform: scale(1); } }

      /* Compare Checkbox */
      .df-compare-wrap {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 4px;
      }
      .df-compare-cb {
        display: none;
      }
      .df-compare-label {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-size: 11px;
        color: var(--df-text-sec);
        cursor: pointer;
        user-select: none;
        transition: all 0.2s ease;
      }
      .df-compare-label:hover { color: var(--df-text-pri); }
      .df-compare-box {
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: 1.5px solid rgba(255,255,255,0.2);
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        flex-shrink: 0;
      }
      .df-compare-cb:checked + .df-compare-label .df-compare-box {
        background: #E30505;
        border-color: #E30505;
      }
      .df-compare-box svg { width: 10px; height: 10px; fill: #fff; opacity: 0; transition: opacity 0.2s; }
      .df-compare-cb:checked + .df-compare-label .df-compare-box svg { opacity: 1; }

      /* Compare Bar */
      #df-compare-bar {
        display: none;
        align-items: center;
        justify-content: space-between;
        padding: 10px 16px;
        background: linear-gradient(135deg, #1a0505, #200808);
        border-top: 1px solid rgba(227,5,5,0.3);
        flex-shrink: 0;
        animation: df-msg-in 0.3s ease;
      }
      #df-compare-bar.df-visible { display: flex; }
      .df-compare-count {
        font-size: 13px;
        font-weight: 600;
        color: var(--df-text-pri);
      }
      .df-compare-count span { color: #E30505; }
      .df-compare-actions { display: flex; gap: 8px; }
      .df-compare-go {
        padding: 7px 16px;
        border-radius: 8px;
        background: linear-gradient(135deg, #E30505, #c50404);
        color: #fff;
        font-size: 12px;
        font-weight: 600;
        border: none;
        cursor: pointer;
        font-family: var(--df-font);
        transition: all 0.3s ease;
      }
      .df-compare-go:hover { box-shadow: 0 4px 12px rgba(227,5,5,0.35); transform: translateY(-1px); }
      .df-compare-clear {
        padding: 7px 12px;
        border-radius: 8px;
        background: rgba(255,255,255,0.06);
        color: var(--df-text-sec);
        font-size: 12px;
        font-weight: 500;
        border: none;
        cursor: pointer;
        font-family: var(--df-font);
        transition: all 0.3s ease;
      }
      .df-compare-clear:hover { background: rgba(255,255,255,0.12); color: var(--df-text-pri); }

      /* Comparison Table */
      .df-compare-table-wrap {
        width: 100%;
        overflow-x: auto;
        margin-top: 10px;
        border-radius: 10px;
        border: 1px solid var(--df-border);
        animation: df-card-in 0.4s ease;
      }
      .df-compare-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
        min-width: 280px;
      }
      .df-compare-table th,
      .df-compare-table td {
        padding: 10px 12px;
        text-align: left;
        border-bottom: 1px solid var(--df-border);
        vertical-align: top;
      }
      .df-compare-table th {
        background: rgba(227,5,5,0.08);
        color: #ff6b6b;
        font-weight: 600;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        white-space: nowrap;
        position: sticky;
        left: 0;
        z-index: 1;
        min-width: 70px;
      }
      .df-compare-table td {
        color: var(--df-text-pri);
        font-weight: 500;
        min-width: 120px;
      }
      .df-compare-table tr:last-child th,
      .df-compare-table tr:last-child td { border-bottom: none; }
      .df-compare-table .df-ct-img {
        width: 56px;
        height: 56px;
        border-radius: 8px;
        object-fit: cover;
      }
      .df-compare-table .df-ct-name {
        font-weight: 600;
        font-size: 12px;
        line-height: 1.3;
        max-width: 140px;
      }
      .df-compare-table .df-ct-price { color: #E30505; font-weight: 700; font-size: 13px; }
      .df-compare-table .df-ct-link {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 5px 10px;
        border-radius: 6px;
        background: linear-gradient(135deg, #E30505, #c50404);
        color: #fff;
        font-size: 11px;
        font-weight: 600;
        text-decoration: none;
        transition: all 0.3s ease;
      }
      .df-compare-table .df-ct-link:hover { box-shadow: 0 2px 8px rgba(227,5,5,0.3); }
      .df-compare-table .df-ct-link svg { width: 10px; height: 10px; fill: currentColor; }
      .df-compare-table .df-ct-feat { color: #22c55e; }
      .df-compare-table .df-ct-no { color: var(--df-text-mut); }

      /* Fullscreen expand (larger screens) */
      @media (min-width: 1200px) {
        #df-chat-panel.df-expanded {
          width: 800px;
          height: 88vh;
          max-height: 88vh;
          bottom: 30px;
          right: 30px;
        }
      }

      /* Mobile */
      @media (max-width: 480px) {
        #df-chat-panel, #df-chat-panel.df-expanded {
          bottom: 0; right: 0;
          width: 100vw; max-width: 100vw;
          height: 100vh; max-height: 100vh;
          border-radius: 0;
        }
        #df-chat-panel.df-open { transform: translateY(0) scale(1); }
        #df-chat-toggle { bottom: 80px; right: 16px; width: 56px; height: 56px; }
        #df-chat-toggle svg { width: 24px; height: 24px; }
        #df-chat-expand { display: none; }
      }
    `;
    document.head.appendChild(style);
  }

  // ──────────────────────────────
  // Product Data Store
  // ──────────────────────────────
  let products = [];
  let isLoaded = false;
  var compareList = [];

  // ──────────────────────────────
  // SVG Icons
  // ──────────────────────────────
  const ICONS = {
    chat: '<svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.2L4 17.2V4h16v12z"/><path d="M7 9h10v2H7zm0-3h10v2H7zm0 6h7v2H7z"/></svg>',
    close: '<svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>',
    send: '<svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>',
    minimize: '<svg viewBox="0 0 24 24"><path d="M19 13H5v-2h14v2z"/></svg>',
    bot: '<svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>',
    user: '<svg viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>',
    external: '<svg viewBox="0 0 24 24"><path d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/></svg>',
    check: '<svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
    expand: '<svg viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>',
    shrink: '<svg viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>'
  };

  // ──────────────────────────────
  // Category & Keyword Maps
  // ──────────────────────────────
  const CATEGORIES = {
    earbuds: {
      keywords: ['earbud','earbuds','earphone','earphones','ear bud','ear phone','headphone','headphones','tws','ows','wireless','bluetooth audio','oyster','stone bud','buds','audio','music','listen','hearing'],
      icon: '🎧', label: 'Earbuds'
    },
    chargers: {
      keywords: ['charger','chargers','charging','charge','cheetah','gan','fast charge','fast charging','usb-c','power adapter','adapter','wall charger','car charger','watts','watt','20w','35w','65w','102w','pd','qc'],
      icon: '⚡', label: 'Chargers'
    },
    cables: {
      keywords: ['cable','cables','cord','wire','usb','type-c','type c','lightning','data cable','charging cable','silicone','braided'],
      icon: '🔌', label: 'Cables'
    },
    speakers: {
      keywords: ['speaker','speakers','boommax','boom max','bluetooth speaker','portable speaker','waterproof speaker','ipx7','bass','sound'],
      icon: '🔊', label: 'Speakers'
    },
    combos: {
      keywords: ['combo','combos','bundle','bundles','deal','deals','pack','package','set','value pack','together','dap bag','succer'],
      icon: '📦', label: 'Combos'
    },
    powerbanks: {
      keywords: ['powerbank','powerbanks','power bank','power banks','battery','portable charger','backup power','mah'],
      icon: '🔋', label: 'Power Banks'
    }
  };

  const FEATURE_KEYWORDS = {
    wireless: ['wireless','bluetooth','bt','no wire'],
    fast_charging: ['fast charge','fast charging','quick charge','rapid','gan'],
    waterproof: ['waterproof','water resistant','ipx7','ipx','rain','water'],
    affordable: ['cheap','affordable','budget','low price','under'],
    premium: ['premium','best','top','high end','quality','pro'],
    portable: ['portable','travel','compact','small','lightweight','light'],
    iphone: ['iphone','apple','ios'],
    samsung: ['samsung','galaxy'],
    android: ['android','infinix','tecno','oppo','realme']
  };

  // ──────────────────────────────
  // FAQ Knowledge Base
  // ──────────────────────────────
  const FAQ = {
    shipping: {
      patterns: ['shipping','delivery','deliver','ship','how long','when will i get','dispatch'],
      answer: '🚚 We deliver across Nigeria! Orders are typically processed within 24 hours and delivered within 2-5 business days depending on your location. Lagos deliveries are usually within 1-2 days.'
    },
    payment: {
      patterns: ['payment','pay','payment method','how to pay','card','transfer','bank'],
      answer: '💳 We accept multiple payment methods including card payments, bank transfers, and payment on delivery (select locations). All transactions are secured with Shopify checkout.'
    },
    warranty: {
      patterns: ['warranty','guarantee','defective','broken','return','refund','exchange'],
      answer: '🛡️ All digifon products come with a warranty. If you receive a defective item, please contact us within 7 days for a replacement or refund. Visit our store for the full return policy.'
    },
    contact: {
      patterns: ['contact','phone number','email','call','whatsapp','reach','talk to human','support','customer service'],
      answer: '📞 You can reach us through our website at www.digifon.ng or send us a message on our social media channels. We\'re happy to help!'
    },
    location: {
      patterns: ['location','address','where','store','shop','office','physical'],
      answer: '📍 digifon is a Nigerian brand! You can shop all our products at www.digifon.ng with nationwide delivery.'
    }
  };

  // ──────────────────────────────
  // Build Chat UI
  // ──────────────────────────────
  function buildUI() {
    var toggle = document.createElement('button');
    toggle.id = 'df-chat-toggle';
    toggle.setAttribute('aria-label', 'Open chat');
    toggle.innerHTML =
      '<span class="df-icon-chat">' + ICONS.chat + '</span>' +
      '<span class="df-icon-close">' + ICONS.close + '</span>' +
      '<span id="df-chat-badge">1</span>';

    var panel = document.createElement('div');
    panel.id = 'df-chat-panel';
    panel.innerHTML =
      '<div id="df-chat-header">' +
        '<div id="df-chat-avatar">' + ICONS.bot + '</div>' +
        '<div class="df-header-info">' +
          '<div class="df-header-title">' + BOT_NAME + '</div>' +
          '<div class="df-header-status">Online</div>' +
        '</div>' +
        '<div class="df-header-actions">' +
          '<button id="df-chat-expand" class="df-header-btn" aria-label="Maximize chat" title="Maximize">' +
            '<span class="df-icon-expand">' + ICONS.expand + '</span>' +
            '<span class="df-icon-shrink">' + ICONS.shrink + '</span>' +
            '<span class="df-expand-label df-label-expand">Maximize</span>' +
            '<span class="df-expand-label df-label-shrink" style="display:none">Minimize</span>' +
          '</button>' +
          '<button id="df-chat-minimize" class="df-header-btn" aria-label="Close chat" title="Close">' + ICONS.minimize + '</button>' +
        '</div>' +
      '</div>' +
      '<div id="df-chat-messages"></div>' +
      '<div id="df-compare-bar">' +
        '<div class="df-compare-count"><span>0</span> selected to compare</div>' +
        '<div class="df-compare-actions">' +
          '<button class="df-compare-clear">Clear</button>' +
          '<button class="df-compare-go">⚖️ Compare Now</button>' +
        '</div>' +
      '</div>' +
      '<div id="df-chat-input-area">' +
        '<input type="text" id="df-chat-input" placeholder="Ask about products..." autocomplete="off" />' +
        '<button id="df-chat-send" aria-label="Send message">' + ICONS.send + '</button>' +
      '</div>' +
      '<div class="df-powered">Powered by <a href="' + SHOP_URL + '" target="_blank">digifon</a></div>';

    document.body.appendChild(toggle);
    document.body.appendChild(panel);

    toggle.addEventListener('click', toggleChat);
    document.getElementById('df-chat-minimize').addEventListener('click', toggleChat);
    document.getElementById('df-chat-expand').addEventListener('click', toggleExpand);
    document.getElementById('df-chat-send').addEventListener('click', handleSend);
    document.getElementById('df-chat-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') handleSend();
    });
    document.querySelector('.df-compare-clear').addEventListener('click', clearCompare);
    document.querySelector('.df-compare-go').addEventListener('click', showComparison);
  }

  // ──────────────────────────────
  // Toggle Chat
  // ──────────────────────────────
  var chatOpened = false;
  var isExpanded = false;

  function toggleChat() {
    var panel = document.getElementById('df-chat-panel');
    var toggle = document.getElementById('df-chat-toggle');
    var badge = document.getElementById('df-chat-badge');
    var isOpen = panel.classList.contains('df-open');

    if (isOpen) {
      panel.classList.remove('df-open');
      toggle.classList.remove('df-active');
    } else {
      panel.classList.add('df-open');
      toggle.classList.add('df-active');
      if (badge) badge.style.display = 'none';
      if (!chatOpened) {
        chatOpened = true;
        showWelcomeMessage();
      }
      setTimeout(function () { document.getElementById('df-chat-input').focus(); }, 400);
    }
  }

  // ──────────────────────────────
  // Toggle Expand / Shrink
  // ──────────────────────────────
  function toggleExpand() {
    var panel = document.getElementById('df-chat-panel');
    var expandBtn = document.getElementById('df-chat-expand');
    isExpanded = !isExpanded;
    if (isExpanded) {
      panel.classList.add('df-expanded');
      expandBtn.setAttribute('title', 'Minimize');
      expandBtn.setAttribute('aria-label', 'Minimize chat');
    } else {
      panel.classList.remove('df-expanded');
      expandBtn.setAttribute('title', 'Maximize');
      expandBtn.setAttribute('aria-label', 'Maximize chat');
    }
    scrollToBottom();
  }

  // ──────────────────────────────
  // Welcome Message
  // ──────────────────────────────
  function showWelcomeMessage() {
    showTyping();
    setTimeout(function () {
      removeTyping();
      addBotMessage(
        'Hey there! 👋 Welcome to <strong>digifon</strong>!\n\nI\'m your product advisor. I can help you find the perfect phone accessories — earbuds, chargers, cables, speakers, power banks & more.\n\nWhat are you looking for today?'
      );
      showQuickChips([
        { icon: '🎧', label: 'Earbuds', query: 'Show me earbuds' },
        { icon: '⚡', label: 'Chargers', query: 'Show me chargers' },
        { icon: '🔊', label: 'Speakers', query: 'Show me speakers' },
        { icon: '🔋', label: 'Power Banks', query: 'Show me power banks' },
        { icon: '📦', label: 'Combos & Deals', query: 'Show me combo deals' },
        { icon: '🔌', label: 'Cables', query: 'Show me cables' },
        { icon: '⚖️', label: 'Compare', query: 'How do I compare products?' },
        { icon: '❓', label: 'Help', query: 'What can you help me with?' }
      ]);
    }, 800);
  }

  // ──────────────────────────────
  // Message Functions
  // ──────────────────────────────
  function addBotMessage(text, productsList) {
    var container = document.getElementById('df-chat-messages');
    var msg = document.createElement('div');
    msg.className = 'df-msg df-msg-bot';

    var formatted = text.replace(/\n/g, '<br>');
    var html = '<div class="df-msg-avatar">' + ICONS.bot + '</div>' +
      '<div class="df-msg-content"><div class="df-msg-bubble">' + formatted + '</div>';

    if (productsList && productsList.length > 0) {
      html += '<div class="df-products-grid">';
      productsList.forEach(function (p, i) {
        var price = formatPrice(p.variants[0].price);
        var comparePrice = p.variants[0].compare_at_price ? formatPrice(p.variants[0].compare_at_price) : null;
        var image = p.images && p.images.length > 0 ? p.images[0].src : '';
        var available = p.variants.some(function (v) { return v.available; });
        var productUrl = SHOP_URL + '/products/' + p.handle;
        var shortName = truncateName(p.title, 60);

        html += '<div class="df-product-card" style="animation-delay:' + (i * 0.1) + 's">';
        if (image) html += '<img class="df-product-img" src="' + image + '" alt="' + escapeHtml(shortName) + '" loading="lazy" />';
        html += '<div class="df-product-info">' +
          '<div class="df-product-name">' + escapeHtml(shortName) + '</div>' +
          '<div class="df-product-prices">' +
            '<span class="df-product-price">' + price + '</span>' +
            (comparePrice ? '<span class="df-product-compare-price">' + comparePrice + '</span>' : '') +
            (comparePrice ? '<span class="df-product-badge">Sale</span>' : '') +
            (!available ? '<span class="df-product-badge df-sold-out">Sold Out</span>' : '') +
          '</div>' +
          '<a href="' + productUrl + '" target="_blank" rel="noopener" class="df-product-btn' + (!available ? ' df-sold-out-btn' : '') + '">' +
            (available ? 'View Product' : 'Sold Out') + ' ' + ICONS.external +
          '</a>' +
          '<div class="df-compare-wrap">' +
            '<input type="checkbox" class="df-compare-cb" id="df-cmp-' + p.id + '" data-product-id="' + p.id + '"' + (compareList.indexOf(p.id) > -1 ? ' checked' : '') + '>' +
            '<label class="df-compare-label" for="df-cmp-' + p.id + '">' +
              '<span class="df-compare-box"><svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg></span>' +
              'Compare' +
            '</label>' +
          '</div>' +
        '</div></div>';
      });
      html += '</div>';
    }
    html += '</div>';
    msg.innerHTML = html;
    container.appendChild(msg);

    // Attach compare checkbox listeners
    var cbs = msg.querySelectorAll('.df-compare-cb');
    cbs.forEach(function(cb) {
      cb.addEventListener('change', function() {
        var pid = parseInt(this.getAttribute('data-product-id')) || this.getAttribute('data-product-id');
        toggleCompare(pid);
      });
    });

    scrollToBottom();
  }

  function addUserMessage(text) {
    var container = document.getElementById('df-chat-messages');
    var msg = document.createElement('div');
    msg.className = 'df-msg df-msg-user';
    msg.innerHTML = '<div class="df-msg-avatar">' + ICONS.user + '</div>' +
      '<div class="df-msg-bubble">' + escapeHtml(text) + '</div>';
    container.appendChild(msg);
    scrollToBottom();
  }

  function showTyping() {
    var container = document.getElementById('df-chat-messages');
    var typing = document.createElement('div');
    typing.className = 'df-msg df-msg-bot';
    typing.id = 'df-typing-indicator';
    typing.innerHTML = '<div class="df-msg-avatar">' + ICONS.bot + '</div>' +
      '<div class="df-msg-bubble"><div class="df-typing">' +
      '<div class="df-typing-dot"></div><div class="df-typing-dot"></div><div class="df-typing-dot"></div>' +
      '</div></div>';
    container.appendChild(typing);
    scrollToBottom();
  }

  function removeTyping() {
    var t = document.getElementById('df-typing-indicator');
    if (t) t.remove();
  }

  function showQuickChips(chips) {
    var container = document.getElementById('df-chat-messages');
    var div = document.createElement('div');
    div.className = 'df-chips';
    div.style.paddingLeft = '40px';

    chips.forEach(function (chip) {
      var btn = document.createElement('button');
      btn.className = 'df-chip';
      btn.textContent = chip.icon + ' ' + chip.label;
      btn.addEventListener('click', function () {
        div.remove();
        processMessage(chip.query);
      });
      div.appendChild(btn);
    });
    container.appendChild(div);
    scrollToBottom();
  }

  function scrollToBottom() {
    var c = document.getElementById('df-chat-messages');
    setTimeout(function () { c.scrollTop = c.scrollHeight; }, 100);
  }

  // ──────────────────────────────
  // Handle Input
  // ──────────────────────────────
  function handleSend() {
    var input = document.getElementById('df-chat-input');
    var text = input.value.trim();
    if (!text) return;
    input.value = '';
    processMessage(text);
  }

  function processMessage(text) {
    addUserMessage(text);
    showTyping();
    var delay = 600 + Math.random() * 600;
    setTimeout(function () {
      removeTyping();
      generateResponse(text);
    }, delay);
  }

  // ──────────────────────────────
  // Response Engine
  // ──────────────────────────────
  function generateResponse(input) {
    var lower = input.toLowerCase().trim();

    if (isGreeting(lower)) {
      addBotMessage('Hello! 😊 Great to see you here! How can I help you today?\n\nI can recommend products, answer questions about features, or help you find the best deals.');
      showQuickChips([
        { icon: '🎧', label: 'Earbuds', query: 'Show me earbuds' },
        { icon: '⚡', label: 'Chargers', query: 'Show me chargers' },
        { icon: '📦', label: 'Combos', query: 'Show me combo deals' }
      ]);
      return;
    }

    if (isThanks(lower)) {
      addBotMessage('You\'re welcome! 😊 Happy to help. If you need anything else, just ask!\n\nHappy shopping at digifon! 🛍️');
      return;
    }

    if (isGoodbye(lower)) {
      addBotMessage('Goodbye! 👋 Thanks for chatting with digifon. Come back anytime you need help finding the perfect accessories! 🎧⚡');
      return;
    }

    if (isCompareQuery(lower)) {
      if (compareList.length >= 2) {
        showComparison();
      } else {
        addBotMessage('To compare products:\n\n1️⃣ Search for a category (e.g. "Show me earbuds")\n2️⃣ Tick the <strong>Compare</strong> checkbox on 2-4 products\n3️⃣ Click <strong>Compare Now</strong>\n\nLet me show you some products to get started!');
        showQuickChips([
          { icon: '🎧', label: 'Compare Earbuds', query: 'Show me earbuds' },
          { icon: '⚡', label: 'Compare Chargers', query: 'Show me chargers' }
        ]);
      }
      return;
    }

    // Check if query matches a product category BEFORE FAQ
    // (prevents "power banks" triggering payment FAQ via "bank")
    var hasCategory = detectCategory(lower);

    var faqAnswer = !hasCategory ? checkFAQ(lower) : null;
    if (faqAnswer) { addBotMessage(faqAnswer); return; }

    if (isHelpQuery(lower)) {
      addBotMessage(
        'I can help you with:\n\n🎧 <strong>Find products</strong> — "Show me earbuds", "I need a charger"\n💰 <strong>Budget search</strong> — "What do you have under ₦20,000?"\n📱 <strong>Compatibility</strong> — "Best charger for iPhone"\n📦 <strong>Bundle deals</strong> — "Show me combo deals"\n⚖️ <strong>Compare products</strong> — Select 2-4 items to compare side by side\n❓ <strong>Product info</strong> — "Tell me about the Oyster Bud"\n🚚 <strong>Store info</strong> — "Shipping", "Payment methods"\n\nJust ask anything!'
      );
      showQuickChips([
        { icon: '🎧', label: 'Earbuds', query: 'Show me earbuds' },
        { icon: '⚡', label: 'Chargers', query: 'Show me chargers' },
        { icon: '🔊', label: 'Speakers', query: 'Show me speakers' },
        { icon: '⚖️', label: 'Compare', query: 'How do I compare products?' }
      ]);
      return;
    }

    if (!isLoaded || products.length === 0) {
      addBotMessage('I\'m still loading the product catalog. Please try again in a moment! ⏳');
      fetchProducts();
      return;
    }

    var results = searchProducts(lower);
    if (results.length > 0) {
      var category = detectCategory(lower);
      var count = results.length;
      var intro = '';

      if (category) {
        intro = 'Here are our ' + CATEGORIES[category].icon + ' <strong>' + CATEGORIES[category].label + '</strong> — ' + count + ' product' + (count > 1 ? 's' : '') + ' found:';
      } else {
        intro = 'I found ' + count + ' product' + (count > 1 ? 's' : '') + ' matching your search:';
      }

      var budget = extractBudget(lower);
      if (budget) {
        intro = 'Here are products under <strong>₦' + budget.toLocaleString() + '</strong>:';
      }

      addBotMessage(intro, results.slice(0, 5));

      if (results.length > 5) {
        addBotMessage('...and ' + (results.length - 5) + ' more! You can browse all products at <a href="' + SHOP_URL + '/collections/all" target="_blank" style="color:#ff6b6b;">digifon.ng/collections</a>');
      }

      showQuickChips([
        { icon: '🔍', label: 'More details', query: 'Tell me about ' + results[0].title.split(' ').slice(0, 3).join(' ') },
        { icon: '💰', label: 'Budget options', query: 'What\'s under ₦20,000?' },
        { icon: '📦', label: 'Bundle deals', query: 'Show me combo deals' }
      ]);
    } else {
      var specificMatch = findSpecificProduct(lower);
      if (specificMatch) {
        addBotMessage('Here\'s what I found:', [specificMatch]);
      } else {
        addBotMessage(
          'I couldn\'t find products matching that. 🤔 Try searching by category or let me help!\n\nFor example:\n• "Show me earbuds"\n• "I need a fast charger"\n• "What combos do you have?"'
        );
        showQuickChips([
          { icon: '🎧', label: 'Earbuds', query: 'Show me earbuds' },
          { icon: '⚡', label: 'Chargers', query: 'Show me chargers' },
          { icon: '📦', label: 'All Products', query: 'Show me all products' }
        ]);
      }
    }
  }

  // ──────────────────────────────
  // Product Search & Scoring
  // ──────────────────────────────
  function searchProducts(query) {
    var lower = query.toLowerCase();
    if (lower.includes('all product') || lower.includes('everything') || lower.includes('show all')) {
      return [].concat(products).sort(function (a, b) {
        return (b.variants.some(function (v) { return v.available; }) ? 1 : 0) -
               (a.variants.some(function (v) { return v.available; }) ? 1 : 0);
      });
    }

    var budget = extractBudget(lower);
    var detectedCategory = detectCategory(lower);
    var words = lower.split(/\s+/);

    var scored = products.map(function (product) {
      var score = 0;
      var pTitle = product.title.toLowerCase();
      var pBody = (product.body_html || '').toLowerCase().replace(/<[^>]*>/g, ' ');
      var pType = (product.product_type || '').toLowerCase();
      var pTags = (product.tags || []).map(function (t) { return t.toLowerCase(); });
      var combined = pTitle + ' ' + pBody + ' ' + pType + ' ' + pTags.join(' ');

      if (detectedCategory) {
        var cat = CATEGORIES[detectedCategory];
        for (var k = 0; k < cat.keywords.length; k++) {
          if (combined.includes(cat.keywords[k])) { score += 10; break; }
        }
        if (pType.includes(detectedCategory) || pType.includes(cat.label.toLowerCase())) score += 15;
        pTags.forEach(function (tag) { if (cat.keywords.includes(tag)) score += 8; });
      }

      words.forEach(function (word) {
        if (word.length < 3) return;
        if (pTitle.includes(word)) score += 5;
        if (pBody.includes(word)) score += 2;
        if (pTags.some(function (t) { return t.includes(word); })) score += 4;
      });

      Object.keys(FEATURE_KEYWORDS).forEach(function (feature) {
        FEATURE_KEYWORDS[feature].forEach(function (kw) {
          if (lower.includes(kw) && combined.includes(kw)) score += 6;
        });
      });

      if (budget) {
        var price = parseFloat(product.variants[0].price);
        if (price <= budget) score += 5; else score = -1;
      }

      if (product.variants.some(function (v) { return v.available; })) score += 3;

      return Object.assign({}, product, { score: score });
    });

    return scored.filter(function (p) { return p.score > 5; })
                 .sort(function (a, b) { return b.score - a.score; });
  }

  function findSpecificProduct(query) {
    var lower = query.toLowerCase();
    return products.find(function (p) {
      var title = p.title.toLowerCase();
      var words = lower.split(/\s+/).filter(function (w) { return w.length > 3; });
      return words.filter(function (w) { return title.includes(w); }).length >= 2;
    });
  }

  function detectCategory(query) {
    var lower = query.toLowerCase();
    for (var cat in CATEGORIES) {
      for (var i = 0; i < CATEGORIES[cat].keywords.length; i++) {
        if (lower.includes(CATEGORIES[cat].keywords[i])) return cat;
      }
    }
    return null;
  }

  function extractBudget(query) {
    var lower = query.toLowerCase();
    var patterns = [
      /under\s*₦?\s*([\d,]+)/i, /below\s*₦?\s*([\d,]+)/i,
      /less\s*than\s*₦?\s*([\d,]+)/i, /budget\s*₦?\s*([\d,]+)/i,
      /max\s*₦?\s*([\d,]+)/i, /₦([\d,]+)/i,
      /under\s*₦?\s*(\d+)k/i, /below\s*₦?\s*(\d+)k/i
    ];
    for (var i = 0; i < patterns.length; i++) {
      var match = lower.match(patterns[i]);
      if (match) {
        var amount = match[1].replace(/,/g, '');
        if (lower.includes('k') && amount.length <= 3) return parseInt(amount) * 1000;
        return parseInt(amount);
      }
    }
    return null;
  }

  // ──────────────────────────────
  // Conversational Checks
  // ──────────────────────────────
  function isGreeting(t) {
    var g = ['hello','hi','hey','good morning','good afternoon','good evening','howdy','yo','sup','greetings','hiya','what\'s up','whats up'];
    return g.some(function (x) { return t.startsWith(x) || t === x; });
  }
  function isThanks(t) {
    var th = ['thank','thanks','thank you','thx','appreciate','helpful','great help','awesome','nice'];
    return th.some(function (x) { return t.includes(x); });
  }
  function isGoodbye(t) {
    var b = ['bye','goodbye','good bye','see you','later','take care','ttyl'];
    return b.some(function (x) { return t.includes(x); });
  }
  function isHelpQuery(t) {
    var h = ['help','what can you do','how does this work','what do you offer','assist','guide','options'];
    return h.some(function (x) { return t.includes(x); });
  }
  function checkFAQ(t) {
    for (var key in FAQ) {
      for (var i = 0; i < FAQ[key].patterns.length; i++) {
        if (t.includes(FAQ[key].patterns[i])) return FAQ[key].answer;
      }
    }
    return null;
  }
  function isCompareQuery(t) {
    var c = ['compare','comparison','versus','vs','difference','differ','which is better','which one'];
    return c.some(function(x) { return t.includes(x); });
  }

  // ──────────────────────────────
  // Utilities
  // ──────────────────────────────
  function formatPrice(p) { return '₦' + parseFloat(p).toLocaleString('en-NG'); }
  function truncateName(n, m) { return n.length <= m ? n : n.substring(0, m).trim() + '…'; }
  function escapeHtml(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }

  // ──────────────────────────────
  // Compare Functions
  // ──────────────────────────────
  function toggleCompare(productId) {
    var idx = compareList.indexOf(productId);
    if (idx > -1) {
      compareList.splice(idx, 1);
    } else {
      if (compareList.length >= 4) {
        var cb = document.getElementById('df-cmp-' + productId);
        if (cb) cb.checked = false;
        addBotMessage('⚠️ You can compare up to <strong>4 products</strong> at a time. Please remove one first.');
        return;
      }
      compareList.push(productId);
    }
    updateCompareBar();
  }

  function updateCompareBar() {
    var bar = document.getElementById('df-compare-bar');
    var countEl = bar.querySelector('.df-compare-count span');
    countEl.textContent = compareList.length;
    if (compareList.length >= 2) {
      bar.classList.add('df-visible');
    } else {
      bar.classList.remove('df-visible');
    }
  }

  function clearCompare() {
    compareList = [];
    document.querySelectorAll('.df-compare-cb').forEach(function(cb) { cb.checked = false; });
    updateCompareBar();
  }

  function showComparison() {
    if (compareList.length < 2) return;
    var selected = compareList.map(function(id) {
      return products.find(function(p) { return p.id === id; });
    }).filter(Boolean);

    addUserMessage('Compare ' + selected.length + ' products');
    showTyping();
    setTimeout(function() {
      removeTyping();
      addComparisonTable(selected);
      clearCompare();
    }, 600);
  }

  function addComparisonTable(items) {
    var container = document.getElementById('df-chat-messages');
    var msg = document.createElement('div');
    msg.className = 'df-msg df-msg-bot';
    msg.style.maxWidth = '100%';

    var html = '<div class="df-msg-avatar">' + ICONS.bot + '</div>' +
      '<div class="df-msg-content" style="width:100%;min-width:0;">' +
      '<div class="df-msg-bubble">⚖️ Here\'s your <strong>product comparison</strong>:</div>' +
      '<div class="df-compare-table-wrap"><table class="df-compare-table">';

    // Image row
    html += '<tr><th>Product</th>';
    items.forEach(function(p) {
      var img = p.images && p.images.length > 0 ? p.images[0].src : '';
      html += '<td>' + (img ? '<img class="df-ct-img" src="' + img + '" alt="" />' : '—') + '</td>';
    });
    html += '</tr>';

    // Name row
    html += '<tr><th>Name</th>';
    items.forEach(function(p) {
      html += '<td class="df-ct-name">' + escapeHtml(truncateName(p.title, 50)) + '</td>';
    });
    html += '</tr>';

    // Price row
    html += '<tr><th>Price</th>';
    items.forEach(function(p) {
      html += '<td class="df-ct-price">' + formatPrice(p.variants[0].price) + '</td>';
    });
    html += '</tr>';

    // Savings row
    html += '<tr><th>Savings</th>';
    items.forEach(function(p) {
      if (p.variants[0].compare_at_price) {
        var saved = parseFloat(p.variants[0].compare_at_price) - parseFloat(p.variants[0].price);
        var pct = Math.round((saved / parseFloat(p.variants[0].compare_at_price)) * 100);
        html += '<td class="df-ct-feat">Save ₦' + saved.toLocaleString('en-NG') + ' (' + pct + '%)</td>';
      } else {
        html += '<td class="df-ct-no">—</td>';
      }
    });
    html += '</tr>';

    // Type row
    html += '<tr><th>Type</th>';
    items.forEach(function(p) {
      html += '<td>' + (p.product_type || '—') + '</td>';
    });
    html += '</tr>';

    // Colors/Variants row
    html += '<tr><th>Colors</th>';
    items.forEach(function(p) {
      var colors = p.options && p.options.length > 0 ? p.options[0].values.join(', ') : '—';
      html += '<td>' + colors + '</td>';
    });
    html += '</tr>';

    // Extract key features from body_html
    var featureLabels = ['Bluetooth', 'Waterproof', 'Fast Charging', 'USB-C', 'Battery/Playtime', 'Warranty'];
    var featureChecks = [
      function(b) { var m = b.match(/bluetooth\s*([\d.]+)/i); return m ? 'BT ' + m[1] : (b.match(/bluetooth/i) ? '✓' : '—'); },
      function(b) { var m = b.match(/ipx(\d)/i); return m ? 'IPX' + m[1] : (b.match(/waterproof|water.?resistant/i) ? '✓' : '—'); },
      function(b) { var m = b.match(/(\d+)\s*w/i); return m ? m[1] + 'W' : (b.match(/fast.?charg/i) ? '✓' : '—'); },
      function(b) { return b.match(/usb.?c/i) ? '✓' : '—'; },
      function(b) { var m = b.match(/(\d+)\s*(?:hour|hr|h)\s*(?:of\s*)?(?:play|battery|use)/i); return m ? m[1] + ' hrs' : (b.match(/\d+\s*mah/i) ? b.match(/\d+\s*mah/i)[0] : '—'); },
      function(b) { return b.match(/warranty|guarantee/i) ? '✓' : '—'; }
    ];

    featureLabels.forEach(function(label, idx) {
      html += '<tr><th>' + label + '</th>';
      items.forEach(function(p) {
        var body = (p.body_html || '').replace(/<[^>]*>/g, ' ');
        var val = featureChecks[idx](body);
        var cls = (val !== '—') ? 'df-ct-feat' : 'df-ct-no';
        html += '<td class="' + cls + '">' + val + '</td>';
      });
      html += '</tr>';
    });

    // Availability row
    html += '<tr><th>In Stock</th>';
    items.forEach(function(p) {
      var avail = p.variants.some(function(v) { return v.available; });
      html += '<td class="' + (avail ? 'df-ct-feat' : 'df-ct-no') + '">' + (avail ? '✓ In Stock' : '✗ Sold Out') + '</td>';
    });
    html += '</tr>';

    // Buy link row
    html += '<tr><th>Buy</th>';
    items.forEach(function(p) {
      html += '<td><a href="' + SHOP_URL + '/products/' + p.handle + '" target="_blank" rel="noopener" class="df-ct-link">Buy Now ' + ICONS.external + '</a></td>';
    });
    html += '</tr>';

    html += '</table></div></div>';
    msg.innerHTML = html;
    container.appendChild(msg);
    scrollToBottom();
  }

  // ──────────────────────────────
  // Fetch Products
  // ──────────────────────────────
  function fetchProducts() {
    fetch(PRODUCTS_API)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.products) {
          products = data.products;
          isLoaded = true;
          console.log('[Digifon Chatbot] Loaded ' + products.length + ' products');
        }
      })
      .catch(function (err) {
        console.error('[Digifon Chatbot] Failed to fetch products:', err);
        setTimeout(fetchProducts, 3000);
      });
  }

  // ──────────────────────────────
  // Initialize
  // ──────────────────────────────
  function init() {
    injectStyles();
    buildUI();
    fetchProducts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
